export const MutationTypes = {
  SET_SCOPE: "SET_SCOPE",
  SET_THEME: "SET_THEME"
}
